<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
</script>

<template>
  <a :href="product.permalink" class="link-underline text-xl font-bold">
    {{ product.name }}
  </a>
</template>
